<template>
  <div class="product-tiles">
    <div v-if="headerText || showAllRoute" class="product-tiles__header">
      <div :class="['product-tiles__header-text', { 'product-tiles__header-text--prominent-header': props.prominentHeader }]">
        {{ headerText }}
      </div>
      <router-link
        v-if="showAllRoute"
        :to="showAllRoute"
        class="product-tiles__header-button">
        {{ showAllText }}
      </router-link>
    </div>
    <ul :class="['product-tiles__list', { 'product-tiles--show-container-background': props.showContainerBackground }]" :style="rootStyles">
      <li v-for="product in productTiles" :key="product.databaseId">
        <product-tile
          :product-id="product.databaseId"
          :product-image="product.image.mediaItemUrl"
          :default-currency="product.defaultCurrency"
          :product-link="product.uri"
          :product-name="product.name"
          :vendor-slug="product.vendor.slug"
          :vendor-name="product.vendor.name"
          :soundcloud-id="product.productSpecs?.productSoundcloudCode"
          :soundcloud-id-type="product.productSpecs?.soundcloudShortcode?.includes('/playlists/') ? 'playlist' : 'track'"
          :product-variations="product.variations?.nodes"
          :product-subscription-options="product.productSubscriptionOptions"
          :product-specs="product.productSpecs"
          :sale-badges="product.productSaleBadges" />
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { computed, toRefs } from "#imports";

const props = withDefaults(defineProps<{
  productTiles: Array,
  tilesPerRow: number,
  headerText?: String,
  prominentHeader?: Boolean,
  showContainerBackground: Boolean,
  showAllRoute?: String,
  showAllText?: String,
}>(), {
  tilesPerRow: 4,
  showAllText: 'Explore all',
});

const { productTiles } = toRefs(props)

const rootStyles = computed(() => {
  return {
    '--tiles-per-row': props.tilesPerRow,
  }
})
</script>

<style lang="scss">
@use "~/common/scss/container";
@use "~/common/scss/typography";
@use "~/common/scss/helpers";
@use "~/common/scss/mq";
@use "~/common/scss/variables";

.product-tiles {
  &--show-container-background {
    background-color: #EDEDED;
    border-radius: 5px;
    padding: 1.2rem;
  }

  &__header {
    align-items: baseline;
    display: flex;
    justify-content: space-between;
    margin: 1rem 0;
  }

  &__header-text {
    font-weight: 600;

    &--prominent-header {
      @include typography.h4();

      padding-top: 1rem;
      text-align: center;
    }
  }

  &__header-button {
    font-size: helpers.px-to-rem(14);
    font-weight: bold;
    text-decoration: none;
  }

  &__list {
    display: grid;
    gap: 1rem;
    grid-template-columns: repeat(2, 1fr);
    justify-content: center;
    list-style: none;
    text-align: left;

    @include mq.aboveMobile() {
      // Wrap as soon as another tile could be 200px width
      grid-template-columns: repeat(var(--tiles-per-row, auto-fit), minmax(#{helpers.px-to-rem(150)}, 1fr));
      gap: 2rem;
    }

    & .product-tile {
      width: 100%;
    }
  }
}
</style>
